import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from "./componentes/Header";
import Main from "./componentes/Main";
import NaoEncontrada from './paginas/NaoEncontrada';
import Sobre from './paginas/Sobre';
import estilos from './App.module.css';
import ListagemItens from './componentes/ListagemItens';
import PegandoDados from './componentes/PegandoDadosAPI';
import ItemPage from './paginas/ItemPage';

function App() {
  const [items, setItems] = useState([]);  // Armazena os dados recebidos da API

  // Callback para tratar os dados recebidos pela API
  const handleDataFetched = (data) => {
    setItems(data.items || []);  // Garante que, caso 'data.items' seja indefinido, um array vazio seja atribuído
  };

  return (
    <div className={estilos.container}>  
      <BrowserRouter>
        {/* Componente responsável por buscar os dados e passar para o 'App' via callback */}
        <PegandoDados onDataFetched={handleDataFetched} /> 
        <Header/>  
        <Main>  
          <Routes>
            <Route path="/" element={<Sobre />}/>
            <Route path="*" element={<NaoEncontrada />}/>
            <Route path="/personagens" element={<ListagemItens dados={items}/>}/>
            <Route path="/personagem/:id" element={<ItemPage dados={items} />}/>
          </Routes>
        </Main>
      </BrowserRouter>
    </div>
  );
}

export default App;
